<template>
  <div class="form form-specification">
    <h5>{{ $t("message.contracts.document_specification") }}</h5>
    <validation
      v-if="document_id != 'new'"
      :action="go_to_error"
      section="specification"
      :contractId="$route.params.id"
      :item="document_id"
    />
    <br />
    <!-- <div class="alert mt-2 alert-success rounded d-flex" v-if="Invoice.IsSigned" >
				<span style="flex-basis: 50%">
					{{$t('message.contracts.signed_message_'+Invoice.SignatureType)}} {{(Invoice.SignDate)}}<br>
					{{Invoice.SignatureName}}
				</span>
			</div> -->
    <div class="row">
      <div class="col-md-6">
        <!-- <div class="row"> -->
        <!-- <div class="col-10"> -->
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group required',
            buyer_focused ? 'focused' : '',
            $v.attis_contracts.attis_contract_byer.$error ? 'has-danger' : '',
          ]"
        >
          <v-select-popup
            type="company"
            :placeholder="$t('message.contracts.invoice_document_buyer')"
            v-model="attis_contracts.attis_contract_byer"
            
          />

          <!-- <v-select id="invoice_document_buyer" :options="companies" label="display_text" :class="['form-control', typeof Invoice.InvoiceByer !== 'undefined' && Invoice.InvoiceByer.value!==''?'vs--selected':'']" @search="fetchContragents"  v-model="Invoice.InvoiceByer" :placeholder="$t('message.contracts.invoice_document_buyer')" @focus="buyerFocused" @blur="buyerBlurred" :disabled="is_field_readonly"></v-select>	
	                   		<label for="invoice_document_buyer" class="form-label-group-label shorter">{{$t('message.contracts.invoice_document_buyer')}}</label> -->
          <!-- <label
            v-if="
              form_error && !$v.attis_contracts.attis_contract_byer.required
            "
            class="control-label text-danger d-block"
            >{{ $t("message.errors.required") }}</label
          > -->
        </span>
        <!-- </div> -->
        <!-- <div class="col-2">
						<button v-if="!is_field_readonly" class="btn btn-sm btn-outline-info float-right"  style="height: 56px;margin-top: 8px;" @click="addByer"><i class="fa fa-plus"></i></button>
					</div> -->
        <!-- </div> -->
      </div>
      <div class="col-md-6">
        <!-- <div class="row"> -->
        <!-- <div class="col-1"> -->
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group required',
            seller_focused ? 'focused' : '',
            $v.attis_contracts.attis_contract_seller.$error ? 'has-danger' : '',
          ]"
        >
          <v-select-popup
            type="company"
            :placeholder="$t('message.contracts.invoice_document_seller')"
            v-model="attis_contracts.attis_contract_seller"
            
          />

          <!-- <v-select id="invoice_document_seller" :options="companies" label="display_text" :class="['form-control', typeof Invoice.InvoiceSeller !== 'undefined' && Invoice.InvoiceSeller.value!==''?'vs--selected':'']" @search="fetchContragents"  v-model="Invoice.InvoiceSeller" :placeholder="$t('message.contracts.invoice_document_seller')" @focus="sellerFocused" @blur="sellerBlurred" :disabled="is_field_readonly"></v-select>
		                   	<label for="invoice_document_seller" class="form-label-group-label shorter">{{$t('message.contracts.invoice_document_seller')}}</label> -->
          <!-- <label
            v-if="
              form_error && !$v.attis_contracts.attis_contract_seller.required
            "
            class="control-label text-danger d-block"
            >{{ $t("message.errors.required") }}</label
          > -->
        </span>
        <!-- </div> -->
        <!-- <div  class="col-2">
						<button v-if="!is_field_readonly" class="btn btn-sm btn-outline-info float-right"  style="height: 56px;margin-top: 8px;" @click="addSeller"><i class="fa fa-plus"></i></button>
					</div> -->
        <!-- </div> -->
      </div>
    </div>
    <span
      :class="[
        'bmd-form-group mb-2 d-block form-label-group required',
        $v.specifications.spec_number.$error ? 'has-danger' : '',
      ]"
    >
      <input
        type="text"
        class="form-control"
        v-model="specifications.spec_number"
        :placeholder="$t('message.contracts.specifications_spec_number')"
        autocomplete="off"
        style="cursor: auto"
        id="specifications_spec_number"
        :disabled="is_field_readonly"
      />
      <label
        for="specifications_spec_number"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.specifications_spec_number") }}</label
      >
      <label
        v-if="form_error && !$v.specifications.spec_number.required"
        class="control-label text-danger d-block"
        >{{ $t("message.errors.required") }}</label
      >
    </span>
    <div class="row">
      <div class="col-md-6">
        <span
          :class="[
            'bmd-form-group mb-2 d-block form-label-group required',
            $v.specifications.spec_place.$error ? 'has-danger' : '',
          ]"
        >
          <input
            type="text"
            class="form-control"
            v-model="specifications.spec_place"
            :placeholder="$t('message.contracts.specifications_spec_place')"
            autocomplete="off"
            style="cursor: auto"
            id="specifications_spec_place"
            :disabled="is_field_readonly"
          />
          <label
            for="specifications_spec_place"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.specifications_spec_place") }}</label
          >
          <label
            v-if="form_error && !$v.specifications.spec_place.required"
            class="control-label text-danger d-block"
            >{{ $t("message.errors.required") }}</label
          >
        </span>
      </div>
      <div class="col-md-6">
        <span
          :class="[
            'bmd-form-group mb-2 d-block form-label-group required',
            $v.specifications.spec_date.$error ? 'has-danger' : '',
          ]"
        >
          <!-- <b-form-datepicker :locale="locale" v-model="Invoice.DocumentDate" :placeholder="$t('message.contracts.invoice_document_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="invoice_document_date"></b-form-datepicker>
                    <label  v-if="Invoice.DocumentDate!=''"  for="invoice_document_date" class="form-label-group-label shorter topped">{{$t('message.contracts.invoice_document_date')}}</label> -->

          <datepicker
            value-type="YYYY-MM-DD"
            format="DD.MM.YYYY"
            @focus="specifications.spec_date = ' '"
            @blur="
              specifications.spec_date == ' '
                ? (specifications.spec_date = '')
                : (specifications.spec_date = specifications.spec_date)
            "
            inputClass="form-control"
            v-model="specifications.spec_date"
            :placeholder="$t('message.contracts.specifications_spec_date')"
            :inputAttr="{ id: 'specifications_spec_date' }"
            :disabled="is_field_readonly"
          />
          <label
            for="specifications_spec_date"
            class="form-label-group-label shorter"
            :class="
              specifications.spec_date != '' && specifications.spec_date != null
                ? 'topped'
                : ''
            "
            >{{ $t("message.contracts.specifications_spec_date") }}</label
          >

          <label
            v-if="form_error && !$v.specifications.spec_date.required"
            class="control-label text-danger d-block"
            >{{ $t("message.errors.required") }}</label
          >
        </span>
      </div>
    </div>

    <v-select-popup
      type="delivery_term"
      required
      v-model="specifications.inkoterms"
      :placeholder="$t('message.contracts.conditions_code')"
    />
    <v-select-popup
      type="payment_type"
      :placeholder="$t('message.contracts.payment_conditions')"
      v-model="specifications.payment_code"
    />

    <h5>{{ $t("message.contracts.invoice_products") }}</h5>
    <div id="products-table">
      <div class="input-group mb-3" style="width: 300px">
        <input
          class="form-control"
          type="text"
          v-model="looking_for_product_number"
          style="height: 32px"
          :placeholder="$t('message.contracts.search_by_number')"
        />
        <div class="input-group-append">
          <button
            @click="lookForProductByNumber"
            class="btn btn-sm btn-outline-success"
          >
            {{ $t("message.contracts.search_by_number_button") }}
          </button>
        </div>
      </div>
      <b-table
        responsive
        striped
        hover
        :items="specifications.goods"
        :tbody-tr-class="rowClass"
        :fields="product_fields"
        :current-page="product_page"
        :per-page="3"
      >
        <template v-slot:cell(spec_good_code)="data">
          <strong>{{ data.item.spec_good_code.display_text }}</strong>
        </template>
        <template v-slot:cell(spec_good_quant)="data">
          <strong
            >{{ data.value }}
            {{ data.item.spec_good_measure.display_text }}</strong
          >
        </template>
        <template v-slot:cell(spec_good_orign)="data">
          <strong>{{ data.item.spec_good_orign.display_text }}</strong>
        </template>

        <template v-slot:cell(spec_good_price)="data">
          <strong
            >{{ addThousandsSeparator(data.value, ",") }}
            {{ data.item.spec_good_curr.display_text }}</strong
          >
        </template>

        <template v-slot:cell(remove)="data">
          <button
            class="btn btn-sm btn-link text-info"
            @click="editProduct((product_page-1) * 3 + data.index)"
          >
            <i class="fa fa-edit"></i></button
          ><button
            v-if="!is_field_readonly"
            class="btn btn-sm btn-link text-danger"
            @click="removeProduct((product_page-1) * 3 + data.index)"
          >
            <i class="fa fa-times"></i>
          </button>
        </template>
      </b-table>
      <div class="d-flex justify-content-center">
        <b-pagination
          v-if="specifications.goods.length / 3 > 1"
          v-model="product_page"
          :total-rows="specifications.goods.length"
          :per-page="3"
        ></b-pagination>
      </div>
    </div>
    <transition name="slide">
      <div
        v-if="add_product || edit_product"
        class="add-product-block alert-success"
        style="margin: 0 -1.5em"
      >
        <span
          :class="[
            'bmd-form-group mb-1 d-block  form-label-group required',
            $v.spec_good.spec_good_name.$error ? 'has-danger' : '',
          ]"
        >
          <input
            type="text"
            class="form-control"
            v-model="spec_good.spec_good_name"
            :placeholder="$t('message.contracts.spec_good_name')"
            autocomplete="off"
            style="cursor: auto"
            id="spec_good_spec_good_name"
            :disabled="is_field_readonly"
          />
          <label
            for="spec_good_spec_good_name"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.spec_good_name") }}</label
          >
          <label
            v-if="form_error && !$v.spec_good.spec_good_name.required"
            class="control-label text-danger d-block"
            >{{ $t("message.errors.required") }}</label
          >
        </span>
        <div class="row">
          <div class="col-md-12">
            <v-select-popup
              type="tnved"
              required
              v-model="spec_good.spec_good_code"
              :placeholder="$t('message.contracts.invoice_products_GoodsCode')"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-8">
            <span
              :class="[
                'bmd-form-group mb-1 d-block form-label-group required',
                $v.spec_good.spec_good_price.$error ? 'has-danger' : '',
              ]"
            >
              <label
                for="invoice_products_Price"
                :class="[
                  'form-label-group-label shorter',
                  spec_good.spec_good_price != '' ? 'high' : '',
                ]"
                >{{ $t("message.contracts.invoice_products_Price") }}</label
              >
              <cleave
                id="invoice_products_Price"
                v-model="spec_good.spec_good_price"
                :options="cleavePrice"
                class="form-control"
                :placeholder="$t('message.contracts.invoice_products_Price')"
                autocomplete="off"
                style="cursor: auto"
                :disabled="is_field_readonly"
              ></cleave>
              <label
                v-if="product_error && !$v.spec_good.spec_good_price.required"
                class="control-label text-danger d-block"
                >{{ $t("message.errors.required") }}</label
              >
            </span>
          </div>
          <div class="col-md-4">
            <span
              :class="[
                'bmd-form-group mb-1 d-block form-label-group required',
                $v.spec_good.spec_good_curr.$error ? 'has-danger' : '',
              ]"
            >
              <v-select-popup
                type="currency"
                required
                :placeholder="$t('message.contracts.spec_good_curr')"
                v-model="spec_good.spec_good_curr"
                :disabled="is_field_readonly"
              />
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <span
              :class="[
                'bmd-form-group mb-1 d-block  form-label-group required ',
                $v.spec_good.spec_good_quant.$error ? 'has-danger' : '',
              ]"
            >
              <input
                type="number"
                id="invoice_products_GoodsQuantity"
                label="display_text"
                :class="['form-control']"
                v-model="spec_good.spec_good_quant"
                :placeholder="
                  $t('message.contracts.invoice_products_GoodsQuantity')
                "
                :disabled="is_field_readonly"
              />
              <label
                for="invoice_products_GoodsQuantity"
                class="form-label-group-label shorter"
                >{{
                  $t("message.contracts.invoice_products_GoodsQuantity")
                }}</label
              >
              <label
                v-if="product_error && !$v.spec_good.spec_good_quant.required"
                class="control-label text-danger d-block"
                >{{ $t("message.errors.required") }}</label
              >
            </span>
          </div>
          <div class="col-md-6">
            <!-- <span :class="['bmd-form-group mb-1 d-block  form-label-group', placeholder_measure?'placeholderStatus':'', measure_focused?'focused':'']"> -->
            <v-select-popup
              type="measure"
              required
              :placeholder="
                $t(
                  'message.contracts.invoice_products_SupplementaryQualifierName',
                )
              "
              v-model="spec_good.spec_good_measure"
              :disabled="is_field_readonly"
            />

            <!-- <v-select id="invoice_products_SupplementaryQualifierName" :options="measures" label="display_text" :class="['form-control', typeof InvoiceGood.SupplementaryQualifierName !== 'undefined' && InvoiceGood.SupplementaryQualifierName.value!==''?'vs--selected':'']" @search="fetchMeasures" @focus="measureFocus" @blur="measureBlur" v-model="InvoiceGood.SupplementaryQualifierName" :placeholder="$t('message.contracts.invoice_products_SupplementaryQualifierName')" :disabled="is_field_readonly"></v-select>
							 <label for="invoice_products_SupplementaryQualifierName" class="form-label-group-label shorter">{{$t('message.contracts.invoice_products_SupplementaryQualifierName')}}</label> -->
            <!-- </span> -->
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <!-- <span :class="['bmd-form-group mb-1 d-block  form-label-group', country_focused?'focused':'']"> -->
            <v-select-popup
              type="country"
              :placeholder="
                $t('message.contracts.invoice_products_OriginCountryCode')
              "
              v-model="spec_good.spec_good_orign"
              :disabled="is_field_readonly"
            />
            <!-- <v-select id="invoice_products_OriginCountryCode" :options="countries" label="display_text" :class="['form-control', typeof InvoiceGood.OriginCountryCode !== 'undefined' && InvoiceGood.OriginCountryCode.value!==''?'vs--selected':'']" @search="fetchCountries" @focus="countryFocus" @blur="countryBlur" v-model="InvoiceGood.OriginCountryCode" :placeholder="$t('message.contracts.invoice_products_OriginCountryCode')" :disabled="is_field_readonly"></v-select>
							 <label for="invoice_products_OriginCountryCode" class="form-label-group-label shorter">{{$t('message.contracts.invoice_products_OriginCountryCode')}}</label> -->
            <!-- </span> -->
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <span :class="['bmd-form-group mb-1 d-block  form-label-group']">
              <input
                type="text"
                class="form-control"
                v-model="spec_good.spec_good_manufacturer"
                :placeholder="$t('message.contracts.spec_good_manufacturer')"
                autocomplete="off"
                style="cursor: auto"
                id="spec_goods_spec_good_manufacturer"
                :disabled="is_field_readonly"
              />
              <label
                for="spec_goods_spec_good_manufacturer"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.spec_good_manufacturer") }}</label
              >
            </span>
          </div>
          <div class="col-md-6">
            <span :class="['bmd-form-group mb-1 d-block  form-label-group']">
              <input
                type="text"
                class="form-control"
                v-model="spec_good.spec_good_model"
                :placeholder="$t('message.contracts.spec_good_model')"
                autocomplete="off"
                style="cursor: auto"
                id="spec_goods_spec_good_model"
                :disabled="is_field_readonly"
              />
              <label
                for="spec_goods_spec_good_model"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.spec_good_model") }}</label
              >
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <span :class="['bmd-form-group mb-1 d-block  form-label-group']">
              <input
                type="text"
                class="form-control"
                v-model="spec_good.spec_good_mark"
                :placeholder="$t('message.contracts.spec_good_mark')"
                autocomplete="off"
                style="cursor: auto"
                id="spec_goods_spec_good_mark"
                :disabled="is_field_readonly"
              />
              <label
                for="spec_goods_spec_good_mark"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.spec_good_mark") }}</label
              >
            </span>
          </div>
          <div class="col-md-4">
            <span :class="['bmd-form-group mb-1 d-block  form-label-group']">
              <input
                type="text"
                class="form-control"
                v-model="spec_good.spec_good_serialnum"
                :placeholder="$t('message.contracts.spec_good_serialnum')"
                autocomplete="off"
                style="cursor: auto"
                id="spec_goods_spec_good_serialnum"
                :disabled="is_field_readonly"
              />
              <label
                for="spec_goods_spec_good_serialnum"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.spec_good_serialnum") }}</label
              >
            </span>
          </div>
          <div class="col-md-4">
            <span :class="['bmd-form-group mb-1 d-block  form-label-group']">
              <input
                type="text"
                class="form-control"
                v-model="spec_good.spec_good_man_year"
                :placeholder="$t('message.contracts.spec_good_man_year')"
                autocomplete="off"
                style="cursor: auto"
                id="spec_goods_spec_good_man_year"
                :disabled="is_field_readonly"
              />
              <label
                for="spec_goods_spec_good_man_year"
                class="form-label-group-label shorter"
                >{{ $t("message.contracts.spec_good_man_year") }}</label
              >
            </span>
          </div>
        </div>

        <div v-if="add_product">
          <button
            id="product-add-modal-btn"
            class="btn btn-sm btn-success"
            @click="addProduct()"
            v-if="add_product && !is_field_readonly"
          >
            {{ $t("message.contracts.add_product") }}
          </button>
          <button
            class="btn btn-sm btn-danger btn-outline-danger float-right"
            @click="hideAddProduct()"
          >
            {{ $t("message.cancel") }}
          </button>
        </div>
        <div v-if="edit_product">
          <button
            class="btn btn-sm btn-success"
            @click="saveProduct()"
            v-if="edit_product && !is_field_readonly"
          >
            {{ $t("message.contracts.save_product") }}
          </button>
          <button
            class="btn btn-sm btn-danger btn-outline-danger float-right"
            @click="hideEditProduct()"
          >
            {{ $t("message.cancel") }}
          </button>
        </div>
      </div>
    </transition>
    <button
      id="product-add-to-invoice-btn"
      class="btn btn-sm btn-success btn-outline-success mb-5"
      @click="showAddProduct()"
      v-if="!add_product && !is_field_readonly"
    >
      {{ $t("message.contracts.add_product") }}
    </button>
    <!-- <div v-if="!add_product && !is_field_readonly" class="form-group">
			<label for="excel-goods-import">{{$t('message.contracts.excel_import_gooods_label')}}</label>
			<input type="file" id="excel-goods-import" :disabled="files_loading" class="form-control"  @change="importGoodsExcel($event, index)">
		</div> -->

    <b-modal
      id="modal-add-buyer"
      :hide-footer="true"
      size="sm"
      :title="$t('message.contracts.add_buyer')"
      button-size="lg"
    >
      <buyer-seller-form
        type="buyer"
        :disabled="is_field_readonly"
      ></buyer-seller-form>
    </b-modal>
    <b-modal
      id="modal-add-seller"
      :hide-footer="true"
      size="sm"
      :title="$t('message.contracts.add_seller')"
      button-size="lg"
    >
      <buyer-seller-form
        type="seller"
        :disabled="is_field_readonly"
      ></buyer-seller-form>
    </b-modal>
    <div
      class="buttons"
      style="position: absolute; bottom: 16px; right: 20%; left: 20px"
    >
      <div class="dropdown">
        <button
          v-if="!is_field_readonly"
          class="btn btn-outline-success btn-sm dropdown-toggle"
          type="button"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          :disabled="buttons_loading"
        >
          {{
            $t(
              is_new
                ? "message.contracts.document_create"
                : "message.contracts.document_save",
            )
          }}&nbsp;&nbsp;
          <div
            class="loading loading-button"
            v-if="loading"
            style="
              border-top-width: 2px;
              border-top-color: #4caf50;
              top: 30px;
              right: -93px;
            "
          ></div>
        </button>
        <div
          class="dropdown-menu"
          name="create-invoice-dropdown-button"
          aria-labelledby="dropdownMenuButton"
        >
          <a
            name="create-invoice-add-button"
            class="dropdown-item"
            style="color: #4caf50"
            @click="saveDocument(false)"
            :disabled="buttons_loading"
            >{{
              $t(
                is_new
                  ? "message.contracts.document_create"
                  : "message.contracts.document_save",
              )
            }}</a
          >
          <a
            class="dropdown-item"
            style="color: #4caf50"
            @click="saveDocument(true)"
            :disabled="buttons_loading"
            >{{
              $t(
                is_new
                  ? "message.contracts.document_create_validate"
                  : "message.contracts.document_save_validate",
              )
            }}</a
          >
          <!-- <a class="dropdown-item" style="color: #4caf50;" v-if="!is_new"  @click="submit_and_sign_dialog()" :disabled=buttons_loading>{{$t('message.contracts.submit_and_sign_button')}}</a> -->
        </div>
      </div>
      <!--<button class="btn btn-success float-left" @click="saveDocument(false)" :disabled=buttons_loading>{{$t(is_new?'message.contracts.document_create':'message.contracts.document_save')}}</button>
			<button class="btn btn-success float-left" @click="saveDocument(true)" :disabled=buttons_loading>{{$t(is_new?'message.contracts.document_create_validate':'message.contracts.document_save_validate')}}</button> -->
      <!--<button v-if="!is_new" class="btn btn-success float-left" @click="submit_and_sign_dialog()" :disabled=buttons_loading>{{$t('message.contracts.submit_and_sign_button')}}</button> -->
      <!-- <button class="btn btn-info float-right" @click="exportEfreight()">e-Freight</button> -->
    </div>
    <b-modal
      id="modal-select-ecp-type-invoice"
      :hide-footer="true"
      size="sm"
      :title="$t('message.contracts.select_ecp_type')"
    >
      <div class="text-center" v-if="!show_code_sign_type">
        <button
          class="btn btn-outline-success btn-round"
          @click="signDocument()"
        >
          {{ $t("message.contracts.sign_with_ecp") }}
        </button>
        <div>
          <small>
            <i>
              {{ $t("message.contracts.only_for_kz") }}
            </i>
          </small>
        </div>
        <hr />
        <button
          class="btn btn-outline-success btn-round"
          @click="sign_with_code()"
        >
          {{ $t("message.contracts.sign_with_code") }}
        </button>
      </div>
      <div class="text-center" v-if="show_code_sign_type">
        <div class="form-group">
          <label for="input-code">
            {{ $t("message.contracts.input_signature_code") }}
          </label>
          <input
            type="text"
            class="form-control"
            id="input-code"
            v-model="sign_with_code_code"
          />
        </div>
        <button
          class="btn btn-success btn-round"
          @click="sign_with_code_phase2()"
        >
          {{ $t("message.contracts.sign_with_code") }}
        </button>
        <hr />
        <button
          class="btn btn-default btn-round btn-sm"
          @click="show_code_sign_type = false"
        >
          {{ $t("message.cancel") }}
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
var querystring = require("querystring");
import { required } from "vuelidate/lib/validators";
export default {
  props: ["goods", "contract_details", "document_id", "is_new", "document"],
  name: "form-speciication",
  data() {
    return {
      is_field_readonly: false,

      files_loading: false,
      looking_for_product_number: "",
      product_page: 0,
      show_code_sign_type: false,
      sign_with_code_code: "",

      buttons_loading: false,
      loading: false,

      add_product: false,
      edit_product: false,
      currently_editing: false,
      form_error: false,
      product_error: false,
      currency_focused: false,
      placeholder_currency: false,
      buyer_focused: false,
      seller_focused: false,
      tnved_focused: false,
      placeholder_tnved: false,
      placeholder_measure: false,
      measure_focused: false,
      country_focused: false,
      currencies: [],
      measures: [],
      companies: [],
      countries: [],
      tnveds: [],

      percent_focused: false,
      discount_focused: false,

      attis_contracts: {
        attis_contract_seller: { value: "" },
        attis_contract_byer: { value: "" },
      },

      specifications: {
        spec_number: "",
        spec_place: "",
        spec_date: "",
        spec_buyer_sign_data: "",
        spec_seller_sign_data: "",
        inkoterms: { value: "" },
        payment_code: { value: "" },
        goods: [
          // {
          //     spec_good_number: '',
          //     spec_good_name: '',
          //     spec_good_code: '',
          //     spec_good_price: '',
          //     spec_good_quant: '',
          //     spec_good_measure: '',
          //     spec_good_orign: '',
          //     spec_good_manufacturer: '',
          //     spec_good_model: '',
          //     spec_good_mark: '',
          //     spec_good_serialnum: '',
          // }
        ],
      },

      cleavePQTY: {
        numeral: false,
        numericOnly: true,
        numeralDecimalScale: 0,
        numeralPositiveOnly: true,
        blocks: [8],
      },
      cleaveWeight: {
        numeral: true,
        // numericOnly: true,
        // numeralDecimalScale: 0,
        numeralPositiveOnly: true,
        blocks: [24],
        numeralDecimalScale: 6,
      },
      cleavePrice: {
        numeral: true,
        // numericOnly: true,
        // numeralDecimalScale: 0,
        numeralPositiveOnly: true,
        blocks: [20],
        numeralDecimalScale: 2,
      },

      Invoice: {
        DocumentNumber: "",
        DocumentDate: "",
        CurrencyCode: "",
        PlacesQuantity: "",
        PlacesDescription: "",
        GrossWeightQuantity: "",
        NetWeightQuantity: "",
        GCost: "",
        Discount: "",
        TransportCharges: "",
        InsuranceCharges: "",
        OtherCharges: "",
        TotalCost: "",
        PaymentPeriod: "",
        InvoiceByer: { value: "" },
        InvoiceSeller: { value: "" },
        IsSigned: false,
        SignatureType: "",
        SignDate: "",
        SignatureName: "",
      },
      InvoiceGoods: [],
      spec_good: {
        spec_good_number: "",
        spec_good_name: "",
        spec_good_code: { value: "", display_text: "" },
        spec_good_price: "",
        spec_good_quant: "",
        spec_good_measure: { value: "", display_text: "" },
        spec_good_orign: { value: "", display_text: "" },
        spec_good_manufacturer: "",
        spec_good_model: "",
        spec_good_mark: "",
        spec_good_serialnum: "",
        spec_good_man_year: "",
        spec_good_curr: { value: "", display_text: "" },
      },
      product_fields: [
        {
          key: "spec_good_number",
          label: this.$t("message.contracts.product_number"),
          sortable: false,
        },
        {
          key: "spec_good_name",
          label: this.$t("message.contracts.spec_good_name"),
          sortable: false,
        },
        {
          key: "spec_good_code",
          label: this.$t("message.contracts.invoice_products_GoodsCode"),
          sortable: false,
        },
        {
          key: "spec_good_price",
          label: this.$t("message.contracts.invoice_products_Price"),
          sortable: false,
        },
        {
          key: "spec_good_quant",
          label: this.$t("message.contracts.invoice_products_GoodsQuantity"),
          sortable: false,
        },
        {
          key: "spec_good_orign",
          label: this.$t("message.contracts.spec_good_orign"),
          sortable: false,
        },
        {
          key: "spec_good_manufacturer",
          label: this.$t("message.contracts.spec_good_manufacturer"),
          sortable: false,
        },
        {
          key: "spec_good_model",
          label: this.$t("message.contracts.spec_good_model"),
          sortable: false,
        },
        {
          key: "spec_good_mark",
          label: this.$t("message.contracts.spec_good_mark"),
          sortable: false,
        },
        {
          key: "spec_good_serialnum",
          label: this.$t("message.contracts.spec_good_serialnum"),
          sortable: false,
        },
        {
          key: "spec_good_man_year",
          label: this.$t("message.contracts.spec_good_man_year"),
          sortable: false,
        },
        {
          key: "remove",
          label: "",
        },
      ],
    };
  },
  methods: {
    addThousandsSeparator(n, thousandsSeparatorSymbol) {
      return n;
      return n.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparatorSymbol);
    },
    /**
     * determines if the row should be highlighted
     */
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (parseInt(item.good_no) === parseInt(this.looking_for_product_number))
        return "table-success";
    },
    /**
     * looks for product in the grid by its guid
     */
    lookForProductByNumber() {
      let index =
        this.specifications.goods.findIndex(
          (good) =>
            parseInt(good.good_no) == parseInt(this.looking_for_product_number),
        ) + 1;
      if (!index) index = this.looking_for_product_number;

      const page = Math.ceil(index / 3);
      this.product_page = page;
    },
    /**
     * finds absolute position of the element
     */
    findPos(obj) {
      var curleft = 0;
      var curtop = 0;

      if (obj.offsetParent) {
        do {
          curleft += obj.offsetLeft;
          curtop += obj.offsetTop;
        } while ((obj = obj.offsetParent));

        return { X: curleft, Y: curtop };
      }
    },
    // is_field_readonly() {
    // 	console.log("invoice signed");
    // 	console.log(this.Invoice.IsSigned);
    // 	if (this.Invoice.IsSigned)
    // 		return true;
    // 	return false;
    // },
    /**
     * replaces data-name of the field with field ID for validation purposes
     */
    field_name_replace(input) {
      let replaces = {
        attis_contract_desc: "contract_description",
        attis_contract_subject: "contract_subject",
      };
      return replaces[input];
    },
    /**
     * Navigates user to the field with error
     */
    go_to_error(error) {
      document.querySelector("#products-table").classList.remove("error");
      this.show_banks_error = false;
      this.show_founder_error = false;
      // switch(error.Subsection){
      // 	case 'Invoice':
      console.log("tikrinam tipa ir id");
      console.log(error.Subsection + " " + error.Id + " " + this.document_id);
      if (error.Subsection == "Invoice" && error.Id == this.document_id) {
        switch (error.Value) {
          case "Invoice.DocumentDate":
            var element = document.querySelector("#invoice_document_date");
            var element_pos = this.findPos(element);
            // element.parentNode.classList.add('error')
            element.focus();
            document
              .querySelector("#modal-document")
              .scrollTo(0, element_pos.Y - 50);
            break;
          case "Invoice.CurrencyCode":
            var element = document.querySelector("#invoice_document_currency");
            var element_pos = this.findPos(element);
            // element.parentNode.classList.add('error')
            element.querySelector("input").focus();
            document
              .querySelector("#modal-document")
              .scrollTo(0, element_pos.Y - 50);
            break;
          case "Invoice.GrossWeightQuantity":
            var element = document.querySelector(
              "#invoice_document_gross_weight",
            );
            var element_pos = this.findPos(element);
            // element.parentNode.classList.add('error')
            element.focus();
            document
              .querySelector("#modal-document")
              .scrollTo(0, element_pos.Y - 50);
            break;
          case "Invoice.NetWeightQuantity":
            var element = document.querySelector(
              "#invoice_document_net_weight",
            );
            var element_pos = this.findPos(element);
            // element.parentNode.classList.add('error')
            element.focus();
            document
              .querySelector("#modal-document")
              .scrollTo(0, element_pos.Y - 50);
            break;
          case "Invoice.TotalCost":
            var element = document.querySelector(
              "#invoice_document_total_cost",
            );
            var element_pos = this.findPos(element);
            // element.parentNode.classList.add('error')
            element.focus();
            document
              .querySelector("#modal-document")
              .scrollTo(0, element_pos.Y - 50);
            break;
          case "InvoiceByer<>attis_contract_owner":
            var element = document.querySelector("#invoice_document_buyer");
            var element_pos = this.findPos(element);
            // element.parentNode.classList.add('error')
            element.querySelector("input").focus();
            document
              .querySelector("#modal-document")
              .scrollTo(0, element_pos.Y - 50);
            break;
          case "attis_cg_price":
          case "GoodMarking <> attis_cg_good_name":
          case "GoodsCode <> attis_cg_TNVED":
            var element = document.querySelector("#products-table");
            var element_pos = this.findPos(element);
            element.classList.add("error");
            // element.focus()
            document
              .querySelector("#modal-document")
              .scrollTo(0, element_pos.Y - 50);
            break;
        }
      } else {
        setTimeout(() => {
          error.closeFie = true;
          this.$root.$emit("process_contract_error", error);
        }, 500);
      }
    },
    /**
     * get contract XML and sends it to backend along with token from e-mail to sign data
     * after signing it gets the signature code and sends it back to the backend
     * to store signature in document
     */
    sign_with_code_phase2() {
      if (this.sign_with_code_code != "") {
        axios
          .get(
            window.base + "/document/LoadInvoiceXML?doc_id=" + this.document_id,
          )
          .then((response) => {
            var fd = new FormData();
            var xml = response.data.replace(
              '<?xml version="1.0" encoding="utf-16"?>',
              "",
            );
            fd.append("token", this.sign_with_code_code);
            fd.append("data", xml);
            axios
              .post(window.base + "/account/SignData", fd)
              .then((response) => {
                var fd = new FormData();
                fd.append("contract_id", this.document_id);
                fd.append("signature", response.data);
                axios
                  .post(window.base + "/document/AddDocumentSignature", fd)
                  .then(() => {
                    this.loading = false;
                    new Noty({
                      theme: "light",
                      type: "success",
                      text: this.$root.$t("message.message.contract_signed"),
                      timeout: 5000,
                    }).show();
                    this.$bvModal.hide("modal-select-ecp-type-invoice");
                  })
                  .catch((e) => {
                    this.loading = false;
                    new Noty({
                      theme: "light",
                      type: "error",
                      text: this.$root.$t(
                        "message.message.contract_not_signed",
                      ),
                      timeout: 5000,
                    }).show();
                    this.$bvModal.hide("modal-select-ecp-type-invoice");
                  });
              });
          });
      }
    },
    /**
     * Sends request to backend to send a code to sign a document without ECP
     */
    sign_with_code() {
      axios
        .get(window.base + "/account/GenerateToken?doc_id=" + this.document_id)
        .then((response) => {
          console.log(response.data);
          this.show_code_sign_type = true;
        });
    },
    /**
     * Displays a dialog to select which method of electronic signature fits user the best.
     */
    submit_and_sign_dialog() {
      this.$bvModal.show("modal-select-ecp-type-invoice");
    },
    /**
     * Initializes electorinc signature for the document.
     * Gets XML from backend.
     * Signs with NCA Layer.
     * Sends signature back to backend to store for future comparison.
     */
    signDocument() {
      this.loading = true;
      axios
        .get(
          window.base + "/document/LoadInvoiceXML?doc_id=" + this.document_id,
        )
        .then((response) => {
          this.xml = response.data.replace(
            '<?xml version="1.0" encoding="utf-16"?>',
            "",
          );
          window.webSocket = new WebSocket("wss://127.0.0.1:13579/");
          window.callback = null;

          window.webSocket.onopen = (event) => {
            window.signXml("PKCS12", "SIGNATURE", this.xml, () => {});
          };

          window.webSocket.onclose = function (event) {
            if (event.wasClean) {
            } else {
              openDialog();
            }
          };

          window.webSocket.onmessage = (event) => {
            var result = JSON.parse(event.data);
            if (result != null) {
              var rw = {
                code: result["code"],
                message: result["message"],
                responseObject: result["responseObject"],
                getResult: function () {
                  return this.result;
                },
                getMessage: function () {
                  return this.message;
                },
                getResponseObject: function () {
                  return this.responseObject;
                },
                getCode: function () {
                  return this.code;
                },
              };
              if (rw.code == "200") {
                var oParser = new DOMParser();
                var oDOM = oParser.parseFromString(
                  rw.getResponseObject(),
                  "application/xml",
                );
                var value =
                  oDOM.getElementsByTagName("ds:SignatureValue")[0].innerHTML;
                var certificate =
                  oDOM.getElementsByTagName("ds:X509Certificate")[0].innerHTML;

                axios
                  .get(window.base + "/account/loadSignatureDetails")
                  .then((response) => {
                    let cert = response.data.cert.replace(
                      /(?:\r\n|\r|\n)/g,
                      "",
                    );
                    if (cert == certificate.replace(/(?:\r\n|\r|\n)/g, "")) {
                      var fd = new FormData();
                      let name = response.data.cert_name;
                      fd.append("document_id", this.document_id);
                      fd.append("contract_id", this.document_id);
                      fd.append("signature", value);
                      fd.append("signature_name", name);
                      fd.append("type", "signature");
                      axios
                        .post(
                          window.base + "/document/AddDocumentSignature",
                          fd,
                        )
                        .then(() => {
                          this.loading = false;
                          this.load(); //refresh status of the contract
                          new Noty({
                            theme: "light",
                            type: "success",
                            text: this.$t("message.message.document_signed"),
                            timeout: 5000,
                          }).show();
                          this.$bvModal.hide("modal-select-ecp-type-invoice");
                        })
                        .catch((e) => {
                          this.loading = false;
                          new Noty({
                            theme: "light",
                            type: "error",
                            text:
                              this.$t("message.message.document_not_signed") +
                              " (" +
                              e +
                              ")",
                            timeout: 5000,
                          }).show();
                          this.$bvModal.hide("modal-select-ecp-type-invoice");
                        });
                    } else {
                      this.loading = false;
                      new Noty({
                        theme: "light",
                        type: "error",
                        text: this.$t(
                          "message.message.document_not_signed_cert_invalid",
                        ),
                        timeout: 5000,
                      }).show();
                    }
                  });

                // var fd = new FormData;
                // fd.append('contract_id', this.document_id)
                // fd.append('signature', value)
                // axios.post(window.base + '/document/AddDocumentSignature', fd).then(()=>{
                // 	this.loading = false
                // 	new Noty({
                // 		theme: 'light',
                // 		type: 'success',
                // 		text: this.$root.$t('message.message.document_signed'),
                // 		timeout: 5000,
                // 	}).show();
                // 	this.$bvModal.hide('modal-select-ecp-type-invoice')
                // }).catch(e=>{
                // 	this.loading = false
                // 	new Noty({
                // 		theme: 'light',
                // 		type: 'error',
                // 		text: this.$root.$t('message.message.document_not_signed'),
                // 		timeout: 5000,
                // 	}).show();
                // 	this.$bvModal.hide('modal-select-ecp-type-invoice')
                // })
                window.webSocket.close();
                // window.webSocket.removeEventListener('message', {})
              }
            }
          };
        });
    },
    exportEfreight() {
      axios
        .get(window.base + "/document/xmlepi?id=" + this.document_id)
        .then((response) => {
          this.$root.$emit("loadDocuments", { category: "all" });
          this.$root.$emit("bv::hide::modal", "modal-document", "#btnShow");
          this.$root.$emit("bv::hide::modal", "modal-document-new", "#btnShow");
        });
    },
    addByer() {
      this.$bvModal.show("modal-add-buyer");
    },
    addSeller() {
      this.$bvModal.show("modal-add-seller");
    },
    findLibValueProduct(lib, value, field, index) {
      if (typeof lib == "string") {
        axios
          .get(
            window.base +
              "/library?type=" +
              lib +
              "&query=&qty=1000" +
              "&lang=" +
              this.$i18n.locale,
          )
          .then((response) => {
            console.log(response.data, value, field, index);
            response.data.forEach((item) => {
              if (
                item.value.trim().toLowerCase() == value.trim().toLowerCase()
              ) {
                this.$set(this.specifications.goods[index], field, item);
              }
            });
          });
      }
    },
    findLibValue(lib, value, field) {
      if (typeof lib == "string") {
        axios
          .get(
            window.base +
              "/library?type=" +
              lib +
              "&query=&qty=1000" +
              "&lang=" +
              this.$i18n.locale,
          )
          .then((response) => {
            response.data.forEach((item) => {
              if (
                item.value.trim().toLowerCase() == value.trim().toLowerCase()
              ) {
                this.$set(this.specifications, field, item);
              }
            });
          });
      } else {
        lib.forEach((item) => {
          if (item.value.trim().toLowerCase() == value.trim().toLowerCase())
            this.$set(this.specifications, field, item);
        });
      }
    },
    saveProduct() {
      // this.$v.$touch('InvoiceGood')
      if (this.$v.spec_good.$invalid) {
        this.product_error = true;
        setTimeout(() => {
          if ($(".has-danger").length > 0)
            $("html,body").animate(
              { scrollTop: $(".has-danger").eq(0).offset().top - 50 },
              1000,
            );
        }, 100);
      } else {
        this.product_error = false;
        this.hideEditProduct();
      }
    },
    hideEditProduct() {
      this.spec_good = {
        GoodMarking: "",
        GoodsCode: { display_text: "", value: "" },
        GoodsDescription: "",
        GoodsQuantity: "",
        SupplementaryQualifierName: { value: "", display_text: "" },
        GrossWeightQuantity: "",
        NetWeightQuantity: "",
        Price: "",
        Discount: "",
        DiscountPercentage: "",
        OriginCountryCode: { value: "", display_text: "" },
        ServiceCharges: "",
        TransportCharges: "",
        OtherCharges: "",
      };
      this.edit_product = false;
    },
    editProduct(index) {
      if(index<0)
        index+=3
      console.log(index)
      this.edit_product = true;
      this.spec_good = this.specifications.goods[index];
      // this.InvoiceGood = this.InvoiceGoods[index];
      this.currently_editing = index;
    },
    removeProduct(index) {
      if(index<0)
        index+=3
      this.specifications.goods.splice(index, 1);
    },
    addProduct() {
      this.$v.$touch("spec_good");
      if (this.$v.spec_good.$invalid) {
        this.product_error = true;
        setTimeout(() => {
          $("html,body").animate(
            { scrollTop: $(".has-danger").eq(0).offset().top - 50 },
            1000,
          );
        }, 100);
      } else {
        this.product_error = false;

        this.specifications.goods.push({
          spec_good_number: this.specifications.goods.length + 1,
          spec_good_name: this.spec_good.spec_good_name,
          spec_good_code: this.spec_good.spec_good_code,
          spec_good_price: this.spec_good.spec_good_price,
          spec_good_quant: this.spec_good.spec_good_quant,
          spec_good_measure: this.spec_good.spec_good_measure,
          spec_good_orign: this.spec_good.spec_good_orign,
          spec_good_manufacturer: this.spec_good.spec_good_manufacturer,
          spec_good_model: this.spec_good.spec_good_model,
          spec_good_mark: this.spec_good.spec_good_mark,
          spec_good_serialnum: this.spec_good.spec_good_serialnum,
          spec_good_curr: this.spec_good.spec_good_curr,
          spec_good_man_year: this.spec_good.spec_good_man_year,
        });
        this.hideAddProduct();
      }
    },
    showAddProduct() {
      this.add_product = true;
    },
    hideAddProduct() {
      this.add_product = false;
      this.spec_good = {
        spec_good_number: "",
        spec_good_name: "",
        spec_good_code: { value: "", display_text: "" },
        spec_good_price: "",
        spec_good_quant: "",
        spec_good_measure: { value: "", display_text: "" },
        spec_good_orign: { value: "", display_text: "" },
        spec_good_manufacturer: "",
        spec_good_model: "",
        spec_good_mark: "",
        spec_good_serialnum: "",
        spec_good_curr: { value: "", display_text: "" },
        spec_good_man_year: "",
      };
    },
    getLibrary(type, query, qty) {
      query = query.toLowerCase();
      axios
        .get(
          window.base +
            "/library?type=" +
            type +
            "&query=" +
            query +
            "&qty=" +
            qty +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          var var_name = type;
          if (type[type.length - 1] == "s") {
            var_name = type + "es";
          } else if (type[type.length - 1] == "y") {
            var_name = type.substring(0, type.length - 1) + "ies";
          } else {
            var_name = type + "s";
          }
          this.$data[var_name] = [];
          response.data.forEach((item) => {
            if (item.value !== "··········") this.$data[var_name].push(item);
          });
        });
    },
    fetchCountries(search, loading) {
      this.getLibrary("country", search, 10000);
    },
    fetchTNVED(search, loading) {
      this.getLibrary("tnved", search, 10000);
    },
    fetchMeasures(search, loading) {
      this.getLibrary("measure", search, 10000);
    },
    fetchCurrencies() {
      this.getLibrary("currency", "", 10000);
    },
    fetchContragents(search, loading) {
      this.getLibrary("company", search, 10000);
    },
    currenciesFocused() {
      this.currency_focused = true;
    },
    currenciesBlurred() {
      this.currency_focused = false;
      // this.validateField('company_status')
    },
    buyerFocused() {
      this.buyer_focused = true;
    },
    buyerBlurred() {
      this.buyer_focused = false;
      // this.validateField('company_status')
    },
    sellerFocused() {
      this.buyer_focused = true;
    },
    sellerBlurred() {
      this.buyer_focused = false;
      // this.validateField('company_status')
    },
    tnvedFocused() {
      this.tnved_focused = true;
    },
    tnvedBlurred() {
      this.tnved_focused = false;
      // this.validateField('product.attis_cg_TNVED')
    },
    measureFocus() {
      this.measure_focused = true;
    },
    measureBlur() {
      this.measure_focused = false;
      // this.validateField('product.attis_cg_TNVED')
    },
    countryFocus() {
      this.country_focused = true;
    },
    countryBlur() {
      this.country_focused = false;
      // this.validateField('product.attis_cg_TNVED')
    },
    findTNVED(code, index) {
      axios
        .get(
          window.base +
            "/library/tnved?code=" +
            code +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          if (typeof response.data[0] !== "undefined")
            this.$set(
              this.specifications.goods[index],
              "spec_good_code",
              response.data[0],
            );
          // this.$set(this.attis_contract_goods[index], 'attis_cg_TNVED', response.data[0])
        });
    },
    load() {
      axios
        .get(
          window.base +
            "/Document/LoadSpecification/?doc_id=" +
            this.document_id,
        )
        .then((response) => {
          this.specifications.spec_number = response.data.spec_number;
          this.specifications.spec_place = response.data.spec_place;
          this.specifications.spec_date = response.data.spec_date;
          this.specifications.inkoterms = response.data.inkoterms;
          this.specifications.payment_code = response.data.payment_code;
          this.findLibValue(
            "delivery_term",
            response.data.inkoterms,
            "inkoterms",
          );
          this.findLibValue(
            "payment_type",
            response.data.payment_code,
            "payment_code",
          );
          if (this.contract_details.attis_contract_type) {
            this.attis_contracts.attis_contract_seller =
              this.contract_details.attis_contract_contragent;
            axios.get(window.base + "/document/getfirm").then((response) => {
              this.attis_contracts.attis_contract_byer = {
                value: response.data.org_code,
                display_text: response.data.org_name,
              };
            });
          } else {
            this.attis_contracts.attis_contract_byer =
              this.contract_details.attis_contract_contragent;
            axios.get(window.base + "/document/getfirm").then((response) => {
              this.attis_contracts.attis_contract_seller = {
                value: response.data.org_code,
                display_text: response.data.org_name,
              };
            });
          }
          // this.$emit('file', response.data.files)
          // this.Invoice.DocumentNumber = response.data.DocumentNumber
          // this.Invoice.DocumentDate = response.data.DocumentDate
          // this.findLibValue('currency', response.data.CurrencyCode, 'CurrencyCode')
          // this.Invoice.PlacesQuantity = response.data.PlacesQuantity
          // this.Invoice.PlacesDescription = response.data.PlacesDescription.trim()
          // this.Invoice.GrossWeightQuantity = response.data.GrossWeightQuantity
          // this.Invoice.NetWeightQuantity = response.data.NetWeightQuantity
          // this.Invoice.GCost = response.data.GCost
          // this.Invoice.Discount = response.data.Discount
          // this.Invoice.TransportCharges = response.data.TransportCharges
          // this.Invoice.InsuranceCharges = response.data.InsuranceCharges
          // this.Invoice.OtherCharges = response.data.OtherCharges
          // this.Invoice.TotalCost = response.data.TotalCost
          // this.Invoice.PaymentPeriod = response.data.PaymentPeriod
          // console.log("is signed");
          // console.log(response.data.IsSigned);
          // if (response.data.IsSigned == true)
          // 	this.Invoice.IsSigned = true
          // this.Invoice.SignatureType = response.data.SignatureType
          // this.Invoice.SignDate = response.data.SignDate
          // this.Invoice.SignatureName = response.data.SignatureName
          // axios.get(window.base + '/document/getFirmDetails?bin='+response.data.InvoiceByer).then(response_=>{
          // 	this.Invoice.InvoiceByer = {value: response.data.InvoiceByer, display_text: response_.data.org_name}
          // })
          // axios.get(window.base + '/document/getFirmDetails?bin='+response.data.InvoiceSeller).then(response_=>{
          // 	this.Invoice.InvoiceSeller = {value: response.data.InvoiceSeller, display_text: response_.data.org_name}
          // })
          // this.findLibValue('company', response.data.InvoiceByer, 'InvoiceByer')
          // this.findLibValue('company', response.data.InvoiceSeller, 'InvoiceSeller')
          // this.Invoice.InvoiceByer = response.data.InvoiceByer
          // this.Invoice.InvoiceSeller = response.data.InvoiceSeller
          // console.log(response.data.product)
          response.data.goods.forEach((good, index) => {
            var tmp_good = {
              // good_no: good.good_no,
              // good_guid: good.good_guid,
              // GoodMarking: good.GoodMarking,
              // GoodsDescription: good.GoodsDescription,
              // GoodsQuantity: good.GoodsQuantity,
              // GrossWeightQuantity: good.GrossWeightQuantity,
              // NetWeightQuantity: good.NetWeightQuantity,
              // Price: good.Price,
              // Discount: good.Discount,
              // DiscountPercentage: good.DiscountPercentage,
              // ServiceCharges: good.ServiceCharges,
              // TransportCharges: good.TransportCharges,
              // OtherCharges: good.OtherCharges,
              // GoodsCode: {value: good.GoodsCode, display_text: ''},
              spec_good_number: good.spec_good_number,
              spec_good_name: good.spec_good_name,
              spec_good_code: { value: good.spec_good_code, display_text: "" },
              spec_good_price: good.spec_good_price,
              spec_good_quant: good.spec_good_quant,
              spec_good_measure: {
                value: good.spec_good_measure,
                display_text: "",
              },
              spec_good_orign: good.spec_good_orign,
              spec_good_manufacturer: good.spec_good_manufacturer,
              spec_good_model: good.spec_good_model,
              spec_good_mark: good.spec_good_mark,
              spec_good_serialnum: good.spec_good_serialnum,
              spec_good_curr: { value: good.spec_good_curr, display_text: "" },
              spec_good_man_year: good.spec_good_man_year,
            };
            this.specifications.goods.push(tmp_good);
            this.findTNVED(good.spec_good_code, index);
            // this.findLibValueProduct('tnved', good.GoodsCode, 'GoodsCode', index)
            this.findLibValueProduct(
              "measure",
              good.spec_good_measure,
              "spec_good_measure",
              index,
            );
            this.findLibValueProduct(
              "currency",
              good.spec_good_curr,
              "spec_good_curr",
              index,
            );
          });
        });
    },
    stringifyProducts() {
      var result = [];
      this.InvoiceGoods.forEach((product, index) => {
        var line = "";

        line = "product[" + index + "].GoodMarking=" + product.GoodMarking;
        line +=
          "&product[" +
          index +
          "].GoodsDescription=" +
          product.GoodsDescription;
        line +=
          "&product[" + index + "].GoodsQuantity=" + product.GoodsQuantity;
        line +=
          "&product[" +
          index +
          "].GrossWeightQuantity=" +
          product.GrossWeightQuantity;
        line +=
          "&product[" +
          index +
          "].NetWeightQuantity=" +
          product.NetWeightQuantity;
        line += "&product[" + index + "].Price=" + product.Price;
        line += "&product[" + index + "].Discount=" + product.Discount;
        line +=
          "&product[" +
          index +
          "].DiscountPercentage=" +
          product.DiscountPercentage;
        line +=
          "&product[" + index + "].ServiceCharges=" + product.ServiceCharges;
        line +=
          "&product[" +
          index +
          "].TransportCharges=" +
          product.TransportCharges;
        line += "&product[" + index + "].OtherCharges=" + product.OtherCharges;
        if (typeof product.GoodsCode !== "undefined")
          line +=
            "&product[" + index + "].GoodsCode=" + product.GoodsCode.value;
        if (typeof product.OriginCountryCode !== "undefined")
          line +=
            "&product[" +
            index +
            "].OriginCountryCode=" +
            product.OriginCountryCode.value;
        if (typeof product.SupplementaryQualifierName !== "undefined")
          line +=
            "&product[" +
            index +
            "].SupplementaryQualifierName=" +
            product.SupplementaryQualifierName.value;

        result.push(line);
      });
      return result.join("&");
    },
    prepareObject(obj) {
      const result = {};

      Object.keys(obj).forEach((key) => {
        if (typeof obj[key] == "object") {
          if (Array.isArray(obj[key])) {
            result[key] = [];
            obj[key].forEach((ar_item) => {
              let tmp_item = {};
              Object.keys(ar_item).forEach((ar_item_key) => {
                if (typeof ar_item[ar_item_key] == "object") {
                  tmp_item[ar_item_key] = ar_item[ar_item_key].value;
                } else {
                  if (
                    ar_item_key == "spec_good_price" ||
                    ar_item_key == "spec_good_quant"
                  ) {
                    // tmp_item[ar_item_key] = parseFloat(ar_item[ar_item_key])
                    if (typeof ar_item[ar_item_key] == "number")
                      tmp_item[ar_item_key] = ar_item[ar_item_key].toString();
                    else tmp_item[ar_item_key] = ar_item[ar_item_key];
                  } else {
                    tmp_item[ar_item_key] = ar_item[ar_item_key];
                  }
                }
              });
              result[key].push(tmp_item);
            });
          } else {
            result[key] = obj[key].value;
          }
        } else {
          result[key] = obj[key];
        }
      });
      return result;
    },
    saveDocument(validate) {
      var data = {
        document: this.document,
      };
      // this.$v.$touch()
      if (this.$v.specifications.$invalid) {
        this.form_error = true;
        setTimeout(() => {
          if ($(".has-danger").length > 0)
            $("html,body").animate(
              { scrollTop: $(".has-danger").eq(0).offset().top - 50 },
              1000,
            );
        }, 100);
      } else {
        if (!validate) {
          this.$root.$emit("show-loading");
          this.buttons_loading = true;
        }

        // Attach file
        // formData.append('file', data.document.file);
        // console.log(tmp, data.document, this.stringifyProducts())
        var t1 = this.$t("message.error");
        axios
          .post(
            window.base +
              (this.is_new === true
                ? "/Document/CreateSpecification" +
                  "?attis_contract_id=" +
                  this.$route.params.id
                : "/Document/UpdateSpecification" +
                  "?doc_id=" +
                  this.document_id),
            this.is_new === true
              ? {...this.prepareObject(this.specifications), 
                attis_contract_byer: this.attis_contracts.attis_contract_byer.value,
                attis_contract_seller: this.attis_contracts.attis_contract_seller.value,
              }
              : {
                  ...this.prepareObject(this.specifications),
                  attis_contract_byer: this.attis_contracts.attis_contract_byer.value,
                  attis_contract_seller: this.attis_contracts.attis_contract_seller.value,
                  spec_id: this.document_id,
                },
          )
          .then((response) => {
            console.log(response.data);
            if (response.data.status == "ok") {
              new Noty({
                theme: "light",
                type: "success",
                text: this.$root.$t("message.message.specification-created"),
                timeout: 5000,
              }).show();
              if (validate && response.data.doc_id !== null) {
                //this.document_id = response.data.doc_id;
                this.$root.$emit("unshow-loading");
                this.buttons_loading = false;
                setTimeout(() => {
                  this.$root.$emit("save-and-validate", response.data.doc_id);
                  //this.current_tab = 0
                  setTimeout(() => {
                    if (document.querySelector("#modal-document") != null)
                      document.querySelector("#modal-document").scrollTo(0, 0);
                    if (document.querySelector("#modal-document-new") != null)
                      document
                        .querySelector("#modal-document-new")
                        .scrollTo(0, 0);
                  }, 500);
                }, 500);
              } else {
                this.$root.$emit("loadDocuments", { category: "all" });
                this.$root.$emit(
                  "bv::hide::modal",
                  "modal-document",
                  "#btnShow",
                );
                this.$root.$emit(
                  "bv::hide::modal",
                  "modal-document-new",
                  "#btnShow",
                );
              }
            } else {
              console.info("else case");
              new Noty({
                theme: "light",
                type: "error",
                text:
                  this.$root.$t("message.message.specification-not-created") +
                  " (" +
                  response.data +
                  ")",
                timeout: 5000,
              }).show();
              if (window.dev_mode) {
                this.$root.$emit(
                  "bv::hide::modal",
                  "modal-document",
                  "#btnShow",
                );
                this.$root.$emit(
                  "bv::hide::modal",
                  "modal-document-new",
                  "#btnShow",
                );
              }
            }
          })
          .catch((e) => {
            console.log(e);
            new Noty({
              theme: "light",
              type: "error",
              text: t1,
              timeout: 5000,
            }).show();
            this.$root.$emit("bv::hide::modal", "modal-document", "#btnShow");
            this.$root.$emit(
              "bv::hide::modal",
              "modal-document-new",
              "#btnShow",
            );
          });
      }
    },
    importGoodsExcel(event, index) {
      if (typeof event.target.files[0] !== "undefined") {
        var fd = new FormData();
        this.files_loading = true;
        fd.append("Files[0]", event.target.files[0]);
        axios
          .post(window.base + "/document/import_excel_goods?type=invoice", fd, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => {
            this.files_loading = false;
            if (response.data !== "error") {
              response.data.forEach((good) => {
                var tmp_good = {};
                //tmp_good.good_guid = good.cgood_guid
                tmp_good = good;
                (tmp_good.good_no = this.InvoiceGoods.length + 1),
                  this.InvoiceGoods.push(tmp_good);
              });
            }
            //this.hideAddProduct();
          });
      }
    },
  },
  mounted() {
    this.fetchCurrencies("");
    this.fetchContragents("");
    this.fetchTNVED("");
    this.fetchMeasures("");
    this.fetchCountries("");

    this.$root.$on("go_to_invoice_error", (error_data) => {
      this.go_to_error(error_data);
    });
    if (this.document_id == "new") {
      var date = new Date();
      this.specifications.spec_number =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) +
        "-" +
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1);
      // this.Invoice.CurrencyCode = this.contract_details.attis_contract_currency
      if (this.contract_details.attis_contract_type) {
        this.attis_contracts.attis_contract_seller =
          this.contract_details.attis_contract_contragent;
        axios.get(window.base + "/document/getfirm").then((response) => {
          this.attis_contracts.attis_contract_byer = {
            value: response.data.org_code,
            display_text: response.data.org_name,
          };
        });
      } else {
        this.attis_contracts.attis_contract_byer =
          this.contract_details.attis_contract_contragent;
        axios.get(window.base + "/document/getfirm").then((response) => {
          this.attis_contracts.attis_contract_seller = {
            value: response.data.org_code,
            display_text: response.data.org_name,
          };
        });
      }

      this.specifications.inkoterms =
        this.contract_details.attis_contract_delivery_term;
      this.specifications.payment_code =
        this.contract_details.attis_contract_payment_type;

      //loading products
      console.log(this.goods)
      this.goods.forEach(good=>{
        let tmp_good = {}
        tmp_good.guid = good.cgood_guid
        tmp_good.spec_good_number = good.cgood_no;
        tmp_good.spec_good_name = good.attis_cg_good_name;
        tmp_good.spec_good_code = good.attis_cg_TNVED;
        tmp_good.spec_good_price = parseFloat(good.attis_cg_price.replace(',','').replace('.', ','));
        tmp_good.spec_good_quant = parseFloat(good.attis_cg_quantity.replace(',','').replace('.', ','));
        tmp_good.spec_good_measure = good.attis_cg_measures;
        tmp_good.spec_good_orign = good.origin_country;
        
        tmp_good.spec_good_manufacturer = "x";
        tmp_good.spec_good_model = "x";
        tmp_good.spec_good_mark = "x";
        tmp_good.spec_good_serialnum = "x";
        tmp_good.spec_good_man_year = 1970;
        tmp_good.spec_good_curr =
          this.contract_details.attis_contract_currency;

        if(good.origin_country == '' || good.origin_country.value == ''){
          tmp_good.spec_good_orign = {value: 'XX', display_text: 'UNDEFINED'};
        }

        this.specifications.goods.push(tmp_good)
      })

    } else {
      this.load();
    }

    // this.$root.$on('saveDocument', (data)=>{
    // 	if(typeof data.document.attis_contract_doc_type === 'object'){
    // 		if(data.document.attis_contract_doc_type.value=='invoice'){
    // 			this.saveDocument(data)
    // 		}
    // 	}else{
    // 		if(data.document.attis_contract_doc_type=='invoce'){
    // 			this.saveDocument(data)
    // 		}
    // 	}
    // })
    this.$root.$on("set.buyer.contragent", (data) => {
      this.attis_contracts.attis_contract_byer = {
        value: data.company.number,
        display_text: data.company.name,
      };
    });
    this.$root.$on("set.seller.contragent", (data) => {
      this.attis_contracts.attis_contract_seller = {
        value: data.company.number,
        display_text: data.company.name,
      };
    });
  },
  computed: {
    locale() {
      var locale = this.$i18n.locale;
      var _this = this;
      switch (locale) {
        case "cn":
          locale = "zh-CN";
          break;
        case "en":
          locale = "en-US";
          break;
      }
      return locale;
    },
    // is_field_readonly() {
    // 	console.log("invoice signed");
    // 	console.log(this.Invoice.IsSigned);
    // 	if (this.Invoice.IsSigned)
    // 		return true;
    // 	return false;
    // },
  },
  watch: {},
  validations: {
    specifications: {
      spec_number: {
        required,
      },
      spec_place: {
        required,
      },
      spec_date: {
        required,
      },
      inkoterms: {
        required,
      },
      goods: {
        required,
      },
    },
    attis_contracts: {
      attis_contract_byer: {
        // required
      },
      attis_contract_seller: {
        // required
      },
    },
    spec_good: {
      spec_good_name: {
        required,
      },
      spec_good_code: {
        required,
      },
      spec_good_price: {
        required,
      },
      spec_good_curr: {
        required,
      },
      spec_good_quant: {
        required,
      },
      spec_good_measure: {
        required,
      },
    },
  },
};
</script>
<style scoped>
#products-table.error {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
</style>
